/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.13.2-49-ge91a4cf-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserRequireCredentialsPolicyFromJSON, UserRequireCredentialsPolicyToJSON, } from './UserRequireCredentialsPolicy';
/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    return true;
}
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'username': json['username'],
        'description': json['description'],
        'credentialPolicy': json['credential_policy'] == null ? undefined : UserRequireCredentialsPolicyFromJSON(json['credential_policy']),
    };
}
export function UserToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'username': value['username'],
        'description': value['description'],
        'credential_policy': UserRequireCredentialsPolicyToJSON(value['credentialPolicy']),
    };
}
